import {Component} from '@angular/core';
import {LocalisationService} from './localisation/localisation.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: [
    './app.component.scss'
  ]
})
export class AppComponent {
  public appName = 'controller';

  private readonly localisation: LocalisationService;

  public constructor(localisation: LocalisationService) {
    this.localisation = localisation;
    this.localisation.start();
  }
}
